import { render, staticRenderFns } from "./referralRewards.vue?vue&type=template&id=ed735dac"
import script from "./referralRewards.vue?vue&type=script&lang=js"
export * from "./referralRewards.vue?vue&type=script&lang=js"
import style0 from "./referralRewards.vue?vue&type=style&index=0&id=ed735dac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports